module.exports = __webpack_public_path__ + "img/swiper_3.5_4_2.6fba2bb2.webp";